module.exports = __webpack_public_path__ + "media/shingles/Design-EyeQ-1b3b8346.png";